module.exports = __webpack_public_path__ + "img/logoRent.1c1732fc.png";